/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { Component } from 'react';
import Cookie from 'js-cookie';
import { withRouter, Link } from 'react-router-dom';

import {
  UserOnTrackSavings
} from '../../../commons/index';

import UserDashBoardSideNavigation from '../../userDashBoard.components/UserDashBoardSideNavigation';
import UserDashBoardTopNavigation from '../../userDashBoard.components/UserDashBoardTopNavigation';

/**
 * @class AllTargetSavings
 */
class AllTargetSavings extends Component {
  state = {
    currentPage: 1,
    pageLimit: 6,
    search: ''
  }

  /**
   *
   * @param {*} event
   * @returns {*} - handle click event
   */
  handleClick = (event) => {
    this.setState({
      currentPage: Number(event.target.id)
    });
  }

  /**
   *
   * @param {*} event
   * @returns {*} - handle search event
   */
  updateSearch = (event) => {
    this.setState({
      search: event.target.value.substr(0, 20)
    });
  }

  /**
   *
   * @returns {*} - render
   */
  render() {
    const {
      currentPage,
      pageLimit,
      search
    } = this.state;

    const { history } = this.props;
    const getTargetSavings = Cookie.getJSON('targetSavings');
    const actualTargetObj = getTargetSavings === undefined ? [] : getTargetSavings;

    // Set out first and last index
    const indexOfLastSaving = currentPage * pageLimit;
    const indexOfFirstSaving = indexOfLastSaving - pageLimit;

    // create new array of object
    const currentSavings = actualTargetObj.slice(indexOfFirstSaving, indexOfLastSaving);

    // Logic to filter by search
    const bySearch = actualTargetObj.filter(
      searchParams => searchParams.planName.toLowerCase().indexOf(search) !== -1
    );

    // Main saving payload
    const mainSavingContent = search ? bySearch : currentSavings;

    // Logic for displaying page numbers
    const pageNumbers = [];
    for (let i = 1; i <= Math.ceil(actualTargetObj.length / pageLimit); i++) {
      pageNumbers.push(i);
    }

    // Pagination
    const renderPageNumbers = pageNumbers.map(number => (
      <li
        key={number}
        className={`pageRemake ${currentPage === number ? 'active' : ''
        }`}
        id={number}
        onClick={this.handleClick}
      >
        <>
          {number}
        </>
      </li>
    ));

    const allTargetSavings = (
      <section className="body_space">
        <div className="go_back">
          <span onClick={history.goBack}>
            <i className="fa fa-arrow-left" aria-hidden="true" />
            {' '}
            {'  '}
             Go Back
          </span>
        </div>
        <div className="investment_upper_part">
          <div className="investment_upper_part_title">
            <div className="first_child">
              <h4>
                Target Savings
              </h4>
              <p>
                View your savings plans
              </p>
            </div>

            <div className="second_child">
              <div className="second_child_icon main">
                <i className="fas fa-search main" />
              </div>
              <div className="second_child_input main">
                <input
                  type="text"
                  value={search}
                  id=""
                  onChange={this.updateSearch}
                  placeholder="Search...."
                />
              </div>
              <div className="second_child_filter main my_savinngs_header_addNewLink">

                <p>
                  <Link to="/savings-plan">
                    <span>
                            +
                    </span>
                        Add new
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="savings_plan_for_interest">
          <div className="savings_category">
            {/* ======================================================= */}
            {
              mainSavingContent.map(savings => (
                <UserOnTrackSavings
                  key={savings.id}
                  title={savings.planName}
                  planType={savings.planType}
                  amountSaved={savings.amountSaved || savings.amount}
                  amountAccrued={savings.amountAccrued}
                  totalInterestEarned={savings.totalInterestEarned}
                  id={savings.id}
                />
              ))
          }
          </div>
        </div>
        {
          search ? '' : (
            <div className="table_pagination">
              <ul className="pagination justify-content-center">
                {renderPageNumbers}
              </ul>
            </div>
          )
        }
      </section>
    );
    return (
      <>
        <UserDashBoardSideNavigation />
        <div className="main_body_wrapper">
          <UserDashBoardTopNavigation />
          {allTargetSavings}
        </div>
      </>
    );
  }
}

export default withRouter(AllTargetSavings);
